import { useIntl } from 'react-intl';

import { useSearchStore } from '../../context';

const MAX_SEARCH_RESULT_COUNT = 10_000_000;

export const useLimitedSearchCount = (): string => {
  const count = useSearchStore((store) => store.count);
  const { formatNumber } = useIntl();

  const limitedSearchResultCount =
    count > MAX_SEARCH_RESULT_COUNT
      ? `${formatNumber(MAX_SEARCH_RESULT_COUNT)}+`
      : formatNumber(count);

  return limitedSearchResultCount;
};
